import { useEffect, useState } from "react";

/**
 * 좁은 화면(기본 640px 이하) 여부. matchMedia가 없는 환경(테스트·SSR)에서는 false.
 * 검색바·결과 탭·카드가 모바일 배치를 고를 때 같은 기준을 쓴다.
 */
export function useNarrowViewport(maxWidth = 640) {
  const query = `(max-width: ${maxWidth}px)`;
  const read = () => {
    try {
      return typeof window !== "undefined" && typeof window.matchMedia === "function"
        ? window.matchMedia(query).matches
        : false;
    } catch (_) {
      return false;
    }
  };
  const [narrow, setNarrow] = useState(read);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    let media;
    try { media = window.matchMedia(query); } catch (_) { return undefined; }
    const update = () => setNarrow(Boolean(media.matches));
    update();
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", update);
      return () => media.removeEventListener("change", update);
    }
    if (typeof media.addListener === "function") {
      media.addListener(update);
      return () => media.removeListener(update);
    }
    return undefined;
  }, [query]);
  return narrow;
}
